import React, { Fragment } from "react";
import { useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FormattedMessage } from "react-intl";
import { DATE_FORMAT_FOR_DISPLAY } from "../../../constants/constants";
import { deadlinesPayment } from "../../../constants/scadenze";
import moment from "moment";

const PaymentInfo = props => {
  const payment = useSelector(state =>
    state.deadlinesDetail.subjective && state.deadlinesDetail.subjective.payment
      ? state.deadlinesDetail.subjective.payment
      : null);
  const type = useSelector(state =>
    state.deadlinesDetail.subjective && state.deadlinesDetail.subjective.type
      ? state.deadlinesDetail.subjective.type
      : null);

  const scope = useSelector(state =>
    state.deadlinesDetail.subjective && state.deadlinesDetail.subjective.scope
      ? state.deadlinesDetail.subjective.scope
      : null);

  const getIcon = () => {
    const colorStatus =
      payment.status === "paid" && payment.execution ? "#09822a" : "#D82829";

    const icon =
      payment.status === "paid" && payment.execution
        ? "check-circle"
        : "times-circle";
    return (payment.status === "paid" && payment.execution) ||
      (payment.status === "unpaid" && payment.execution) ? (
        <FontAwesomeIcon
          style={{
            color: colorStatus,
            fontSize: "14px",
            marginRight: "4px"
          }}
          icon={["fal", icon]}
        />
      ) : null;
  };

  const paidDesc = () => {
    let executionMode = "";
    let executionDate = null;
    /** Se compensation è true allora non ho modalità di pagamento ma si è chiusa per compensazione */
    if (payment.compensation) {
      executionMode = <FormattedMessage id="deadlines.compensation.describe" />;
    } else if (payment.execution.mode && type !== "rebate") {
      executionMode = (
        <FormattedMessage id={deadlinesPayment[payment.execution.mode]} />
      );
    } else if (type === "rebate" && scope === "other") {
      executionMode = <FormattedMessage id="deadlines.rebate" />;
    } else {
      executionMode = "N.D.";
    }

    if (payment.execution.date) {
      executionDate = moment(payment.execution.date).format(DATE_FORMAT_FOR_DISPLAY);
    }

    return (
      <Fragment>
        <FormattedMessage id="deadlines.pages.detail.paidOffDeadline1" />
        {executionDate && (
          <FormattedMessage id="deadlines.pages.detail.paidOffDeadlineDeterminative" />
        )}{" "}
        {executionDate}
        {executionMode && (
          <FormattedMessage id="deadlines.pages.detail.paidOffDeadline2" />
        )}{" "}
        {executionMode}
      </Fragment>
    );
  };

  const unpaidDesc = () => {
    return (
      <Fragment>
        <FormattedMessage id="deadlines.pages.detail.rejectedPayment" />{" "}
        {payment.execution.date
          ? moment(payment.execution.date).format(DATE_FORMAT_FOR_DISPLAY)
          : "N.D."}
      </Fragment>
    );
  };

  return (payment && payment.status === "paid" && payment.execution) ||
    (payment.status === "unpaid" && payment.execution) ? (
      <div>
        {getIcon()}
        {payment.status === "paid" && payment.execution
          ? paidDesc()
          : unpaidDesc()}
      </div>
    ) : null;
};

export default PaymentInfo;
